var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiYimby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "emojiYimby") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.079 4.233c6.492 0 11.774 5.283 11.774 11.774s-5.283 11.774-11.774 11.774c-2.204 0-4.355-0.616-6.218-1.778l-5.41 1.437 1.508-5.419c-1.082-1.813-1.652-3.894-1.652-6.014 0-6.492 5.283-11.774 11.774-11.774zM16.081 0.039c-8.82 0-15.968 7.149-15.968 15.968 0 2.983 0.82 5.773 2.244 8.163l-1.961 7.246 7.246-1.855c2.45 1.529 5.341 2.414 8.44 2.414 8.82 0 15.968-7.149 15.968-15.968s-7.15-15.968-15.97-15.968h0.002z",
    fill: "#1CA79C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.556 22.069c2.171-0.96 4.538-1.207 6.832-0.859 0.367 0.054 0.797 0.131 1.168 0.206 0.449 0.099 0.962 0.187 1.424 0.324-0.283 0.982-1.052 1.791-1.92 2.283-2.472 1.422-6.155 0.672-7.504-1.952v-0.002z",
    fill: "#1CA79C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.754 15.287l0.563-1.098c0.049-0.094 1.203-2.302 3.486-2.974l0.322 1.093c-0.876 0.256-1.557 0.825-2.027 1.344 1.274-0.15 3.084-0.178 4.098 0.647l-0.719 0.883c-0.866-0.706-3.234-0.485-4.523-0.18l-1.201 0.284z",
    fill: "#1CA79C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.222 18.584c1.445 0 2.616-1.594 2.616-3.559s-1.171-3.559-2.616-3.559c-1.445 0-2.616 1.594-2.616 3.559s1.171 3.559 2.616 3.559z",
    fill: "#1CA79C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiYimby);
export default __webpack_public_path__ + "static/media/emojiYimby.2028dd731745afa826004efbcf862ada.svg";
export { ForwardRef as ReactComponent };